import ufeApi from 'services/api/ufeApi';
import { CHANNELS } from 'constants/Channels';
import urlUtils from 'utils/Url';
import languageLocaleUtils from 'utils/LanguageLocale';
import javascriptUtils from 'utils/javascript';
const { buildQuery } = urlUtils;
const { buildMap } = javascriptUtils;
import { RESULTS_COUNT } from 'constants/constructorConstants';

// https://store-aggregation-eus1-qa2.lower.internal.sephora.com/store-aggregation/swagger-ui/index.html

function getNewProducts(token, payload) {
    const {
        storeId, zipCode, podId, currentPage, pageSize = RESULTS_COUNT.CONTENT_PAGE_SIZE, ref
    } = payload;
    const url = `/gway/v1/dotcom-sys/browse/${podId}`;
    const location = `${languageLocaleUtils.getCurrentLanguage().toLowerCase()}-${languageLocaleUtils.getCurrentCountry()}`;
    const constructorCLientId = !!global.ConstructorioTracker && global.ConstructorioTracker.getClientID();
    const constructorSessionId = !!global.ConstructorioTracker && global.ConstructorioTracker.getSessionID();

    const queryParams = buildQuery(
        buildMap({
            ...(storeId && { storeId }),
            ...(zipCode && { zipCode }),
            ...(currentPage && { currentPage }),
            ...(pageSize && { pageSize }),
            ...(constructorCLientId && { constructorCLientId }),
            ...(constructorSessionId && { constructorSessionId }),
            ref
        })
    );

    const options = {
        method: 'GET',
        headers: {
            authorization: `Bearer ${token}`,
            accept: 'application/json',
            'content-type': 'application/json',
            'content-language': location,
            'x-requested-source': CHANNELS.RWD
        }
    };

    return ufeApi.makeRequest(url + queryParams, options).then(data => {
        return data.errorCode ? Promise.reject(data) : data;
    });
}

export default getNewProducts;
